export default {
	isLogin:false,
	loginInfo:{},
	top:{},
	imglist:{},
	nav:{},
	offsets:{
		//用于交互
		quote_ulmark: null,
		smt_height: null
	},
	languageKey: {
		LANG: {},
		MLANG: {}
	},
	requests:[],
	isFixed: false,
	isMinWidth: false,
	isChangeType: false,
	pcbPageData: null,
	isFromPcb: 1, // 1-常规PCB 2-高端PCB
	isChangeParams: false, // 是否是修改参数
	changeParams: null, // 原单参数 数据
	isLoadingPage: false
}